import axios from "axios";

const axiosPrivate = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

axiosPrivate.interceptors.request.use(
  (config) => {
    // LOCALSTORAGE
    // const token = localStorage.getItem("hayd_auth");

    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    // LOCALSTORAGE

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosPrivate;
